// Shared fetch helper for the pollers in curtain.ts and stream-status.ts: GETs JSON
// from an endpoint with an abort timeout, and returns null on any network error,
// non-OK response, or timeout so callers can simply keep their last known state.
export async function fetchJson<T = unknown>(endpoint: string, timeoutMs: number): Promise<T | null> {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

    try {
        const response = await fetch(endpoint, {
            headers: { Accept: 'application/json' },
            signal: controller.signal
        });

        if (!response.ok) {
            return null;
        }

        return await response.json() as T;
    } catch {
        return null;
    } finally {
        window.clearTimeout(timeout);
    }
}
